import * as React from 'react';
import { isStringAuthorizeHtml, unprotectAuthorizedHtml } from '../../helpers/protectStrings';
var ErrorMessage = function ErrorMessage(props) {
  if (typeof props.text === 'string' && isStringAuthorizeHtml(props.text)) {
    return /*#__PURE__*/React.createElement("p", {
      className: "form-error"
      // eslint-disable-next-line react/no-danger
      ,
      dangerouslySetInnerHTML: {
        __html: unprotectAuthorizedHtml(props.text)
      }
    });
  }
  return /*#__PURE__*/React.createElement("p", {
    className: "form-error"
  }, props.text);
};
export default ErrorMessage;